import React, { useEffect, useState } from "react";
import { ARTIST } from "../data/content";

const NavLink = ({ href, label, testid }) => (
  <a
    href={href}
    data-testid={testid}
    className="text-[11px] uppercase tracking-[0.28em] text-[#F5F5F0]/70 hover:text-[#C5A059] transition-colors duration-300"
  >
    {label}
  </a>
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between gap-6">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-xl md:text-2xl font-bold tracking-tighter text-[#F5F5F0]"
        >
          {ARTIST.name}
          <span className="text-[#C5A059]">.</span>
        </a>

        <nav className="hidden sm:flex items-center gap-6 md:gap-9">
          <NavLink href="#music" label="Music" testid="nav-link-music" />
          <NavLink href="#collector" label="Vinyl" testid="nav-link-collector" />
          <NavLink href="#merch" label="Merch" testid="nav-link-merch" />
          <NavLink href="#connect" label="Connect" testid="nav-link-connect" />
        </nav>

        <a
          href="#collector"
          data-testid="nav-cta-listen"
          className="group hidden md:inline-flex items-center gap-2 border border-[#C5A059] text-[#C5A059] px-4 py-2 text-[10px] uppercase tracking-[0.3em] hover:bg-[#C5A059] hover:text-[#050505] transition-all duration-300"
        >
          Buy Vinyl
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-0.5">
            →
          </span>
        </a>
      </div>
    </header>
  );
}
